export default {
  list: {
    columns: [
      { key: 'key', width: 200 },
      { key: 'name', width: 300 },
      { key: 'lensTypeRef', width: 300 },
      { key: 'supplierRef', width: 150 },
      { key: 'salePrice', width: 100 },
      { key: 'storageType', width: 100 },
      { key: 'note', width: 300 },
    ],
    query: {
      fixedQuery: {
        type: { $eq: 'B' },
      },
    },
  },
  editor: {
    config: { titleSm: 2, titleMd: 1 },
    groups: [
      {
        name: '商品',
        rows: [
          [{ key: 'key' }],
          [{ key: 'name' }],
          [{ key: 'type' }],
          [{ key: 'lensTypeRef' }],
          [{ key: 'brandCode' }, { key: 'brandRef' }],
          [{ key: 'supplierRef' }, { key: 'orderCode' }],
          [{ key: 'unit' }],
          [{ key: 'origin' }],
          [{ key: 'note' }],
          [{ key: 'isContract' }],
          [{ key: 'orderFrom' }],
          [{ key: 'payType' }],
          [{ key: 'spec' }],
          [{ key: 'taxType' }],
          [{ key: 'basicAmount' }],
          [{ key: 'ragicStoreNodeId' }, { key: 'ragicCenterNodeId' }],
        ],
      },
      {
        name: '成本',
        rows: [
          [{ key: 'centerCost' }],
          [{ key: 'storeCost' }],
        ],
      },
      {
        name: '價格',
        rows: [
          [{ key: 'price' }],
          [{ key: 'staffPrice' }],
          [{ key: 'salePrice' }],
        ],
      },
      {
        name: '規格 - B 類',
        rows: [
          [{ key: 'storageType' }],
          [{ key: 'sphereMax' }, { key: 'sphereMin' }],
          [{ key: 'cylinderMax' }, { key: 'cylinderMin' }],
          [{ key: 'axisMax' }, { key: 'axisMin' }],
          [{ key: 'addMax' }, { key: 'addMin' }],
          [{ key: 'SCMax' }, { key: 'SCMin' }],
          [{ key: 'progressive' }],
          [{ key: 'diameter' }],
          [{ key: 'coating' }],
          [{ key: 'ultraviolet' }],
          [{ key: 'refractiveIndex' }],
          [{ key: 'blank' }, { key: 'blankShort' }],
          [{ key: 'design' }],
        ],
      },
    ],
  },
}



// WEBPACK FOOTER //
// ./src/views/ui/productsB.js